/* =========================================================
   JUBI · Rug Size Guide — bespoke (Rolling Tides + Fronda)

   Single-rug templates whose sizes and silhouette path are
   baked into this file. Mounts onto every .sgjb[data-sgjb-mount]
   element on the page; reads template name from a sibling
   <script type="application/sgj-config+json" data-sgjb-data>.
   ========================================================= */
(function () {
  'use strict';

  var INK = 'var(--jubi-ink)';
  var PAPER = 'var(--jubi-paper)';
  var BRONZE = 'var(--jubi-bronze)';
  var BG2 = 'var(--jubi-bone)';

  var STROKE_MAIN =
    'stroke="' + INK + '" stroke-width="1.25" fill="' + PAPER +
    '" stroke-linejoin="round" stroke-linecap="round"';

  function r2(n) { return Math.round(n * 100) / 100; }
  function escapeAttr(s) {
    return String(s)
      .replace(/&/g, '&amp;').replace(/"/g, '&quot;')
      .replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }
  function inToCm(inches) { return Math.round(inches * 2.54); }
  function svgRect(x, y, w, h, rx) {
    return '<rect x="' + r2(x) + '" y="' + r2(y) +
      '" width="' + r2(w) + '" height="' + r2(h) +
      '" rx="' + (rx || 0) + '" ' + STROKE_MAIN + '/>';
  }
  function svgLine(x1, y1, x2, y2) {
    return '<line x1="' + r2(x1) + '" y1="' + r2(y1) +
      '" x2="' + r2(x2) + '" y2="' + r2(y2) +
      '" stroke="' + INK + '" stroke-width="1" stroke-linecap="round"/>';
  }
  function svgCushion(x, y, w, h, rx) {
    return '<rect x="' + r2(x) + '" y="' + r2(y) +
      '" width="' + r2(w) + '" height="' + r2(h) +
      '" rx="' + (rx || 0) + '" fill="' + BG2 +
      '" stroke="' + INK + '" stroke-width="0.75" opacity="0.7"/>';
  }

  /* ---------------------------------------------------------
     scalePath01 — map a 0..1 normalized path to a target
     width × height in pixels. The path is M/L/Z only. Numbers
     are scaled, commands passed through.
     --------------------------------------------------------- */
  function scalePath01(path, w, h) {
    var out = '';
    var tokens = path.split(/\s+/);
    var i = 0;
    while (i < tokens.length) {
      var t = tokens[i];
      if (t === 'M' || t === 'L') {
        out += t + ' ';
        var x = parseFloat(tokens[i + 1]) * w;
        var y = parseFloat(tokens[i + 2]) * h;
        out += r2(x) + ' ' + r2(y) + ' ';
        i += 3;
      } else if (t === 'Z') {
        out += 'Z ';
        i += 1;
      } else {
        i += 1;
      }
    }
    return out.trim();
  }

  /* ---------------------------------------------------------
     Templates — sizes, silhouette path, table column header.
     Sizes are inches: long edge × short edge. The path is
     normalized so x ∈ [0,1] covers the long edge; y spans
     0..viewBoxH for the short edge.
     --------------------------------------------------------- */
  // Source: prototypes/_rolling-tides-path.txt — normalized to a 1×1 box.
  var ROLLING_TIDES_PATH = 'M 0.656 0.000 L 0.748 0.027 L 0.812 0.054 L 0.859 0.081 L 0.889 0.108 L 0.907 0.135 L 0.920 0.162 L 0.928 0.190 L 0.928 0.217 L 0.919 0.243 L 0.897 0.270 L 0.869 0.297 L 0.835 0.324 L 0.808 0.351 L 0.813 0.378 L 0.843 0.405 L 0.878 0.432 L 0.913 0.459 L 0.937 0.486 L 0.955 0.514 L 0.960 0.541 L 0.954 0.568 L 0.941 0.595 L 0.936 0.622 L 0.943 0.649 L 0.957 0.676 L 0.970 0.703 L 0.983 0.730 L 0.995 0.757 L 1.000 0.783 L 1.000 0.810 L 0.996 0.838 L 0.990 0.865 L 0.981 0.892 L 0.964 0.919 L 0.946 0.946 L 0.922 0.973 L 0.885 1.000 L 0.805 1.000 L 0.744 0.973 L 0.667 0.946 L 0.404 0.919 L 0.279 0.892 L 0.210 0.865 L 0.169 0.838 L 0.148 0.810 L 0.130 0.783 L 0.115 0.757 L 0.100 0.730 L 0.080 0.703 L 0.055 0.676 L 0.033 0.649 L 0.013 0.622 L 0.001 0.595 L 0.000 0.568 L 0.007 0.541 L 0.018 0.514 L 0.031 0.486 L 0.054 0.459 L 0.080 0.432 L 0.105 0.405 L 0.128 0.378 L 0.152 0.351 L 0.169 0.324 L 0.179 0.297 L 0.181 0.270 L 0.180 0.243 L 0.180 0.217 L 0.185 0.190 L 0.199 0.162 L 0.220 0.135 L 0.252 0.108 L 0.288 0.081 L 0.326 0.054 L 0.399 0.027 L 0.491 0.000 Z';

  var FRONDA_PATH = 'M 0.4838 0 L 0.5006 0.0012 L 0.5157 0.0066 L 0.5288 0.0168 L 0.5431 0.0096 L 0.5588 0.0113 L 0.5714 0.0227 L 0.5828 0.0353 L 0.5968 0.0361 L 0.6105 0.0273 L 0.626 0.0229 L 0.6423 0.0229 L 0.6575 0.0281 L 0.6691 0.0393 L 0.6787 0.0482 L 0.695 0.0457 L 0.7123 0.0457 L 0.7256 0.054 L 0.7329 0.0683 L 0.7452 0.0743 L 0.7617 0.0722 L 0.778 0.0746 L 0.7929 0.0805 L 0.8009 0.0945 L 0.8039 0.1107 L 0.8167 0.1179 L 0.8326 0.1214 L 0.8459 0.1311 L 0.8548 0.1448 L 0.8544 0.1613 L 0.8686 0.1673 L 0.8834 0.1734 L 0.8934 0.1859 L 0.8929 0.2014 L 0.8898 0.2171 L 0.9053 0.219 L 0.921 0.223 L 0.929 0.237 L 0.929 0.2534 L 0.9242 0.2687 L 0.937 0.2768 L 0.9515 0.2836 L 0.9579 0.2983 L 0.9543 0.3141 L 0.9495 0.3295 L 0.9611 0.3413 L 0.9699 0.355 L 0.9741 0.3701 L 0.9703 0.3859 L 0.9623 0.3999 L 0.969 0.413 L 0.9796 0.426 L 0.9856 0.4409 L 0.9844 0.4577 L 0.9819 0.473 L 0.988 0.4879 L 0.9892 0.5047 L 0.9851 0.5204 L 0.9762 0.534 L 0.9675 0.5478 L 0.9819 0.5535 L 0.994 0.5644 L 0.9952 0.5803 L 0.9887 0.5949 L 0.9807 0.6089 L 0.9896 0.6226 L 0.9985 0.6363 L 0.9988 0.6525 L 0.9906 0.6664 L 0.9792 0.679 L 0.9791 0.6927 L 0.988 0.7064 L 0.989 0.7222 L 0.981 0.7362 L 0.9705 0.7491 L 0.9711 0.7648 L 0.9759 0.7801 L 0.9735 0.7964 L 0.9682 0.8116 L 0.9577 0.8245 L 0.9579 0.84 L 0.9603 0.8563 L 0.9579 0.8717 L 0.9479 0.8849 L 0.9346 0.8946 L 0.9278 0.9091 L 0.9285 0.9247 L 0.9218 0.9393 L 0.9097 0.9495 L 0.8967 0.9601 L 0.882 0.9664 L 0.8785 0.9822 L 0.8745 0.9979 L 0.8665 1.0119 L 0.8548 1.0237 L 0.8411 1.0325 L 0.8339 1.0455 L 0.8303 1.0614 L 0.8232 1.0757 L 0.8118 1.0884 L 0.7981 1.0972 L 0.7841 1.1052 L 0.7738 1.1183 L 0.7677 1.1331 L 0.7575 1.1462 L 0.7447 1.1554 L 0.7303 1.1625 L 0.7139 1.1649 L 0.6998 1.1726 L 0.691 1.1863 L 0.6821 1.2 L 0.6692 1.2106 L 0.6544 1.2168 L 0.638 1.219 L 0.6232 1.2252 L 0.6099 1.2349 L 0.5959 1.2429 L 0.5806 1.2479 L 0.5643 1.2503 L 0.5479 1.2503 L 0.5316 1.2503 L 0.5152 1.2479 L 0.4984 1.2491 L 0.4811 1.2491 L 0.4642 1.2503 L 0.4474 1.2491 L 0.431 1.2467 L 0.4176 1.2386 L 0.4041 1.2296 L 0.3884 1.2259 L 0.3719 1.2238 L 0.3557 1.221 L 0.3424 1.2112 L 0.3319 1.1983 L 0.3213 1.1853 L 0.3065 1.1793 L 0.2916 1.1733 L 0.2758 1.1697 L 0.261 1.1635 L 0.2489 1.1526 L 0.2371 1.1408 L 0.2231 1.1328 L 0.208 1.1274 L 0.1949 1.119 L 0.1834 1.1064 L 0.1733 1.0933 L 0.1674 1.0784 L 0.1628 1.0629 L 0.1539 1.0493 L 0.1399 1.0413 L 0.1282 1.0295 L 0.1191 1.0159 L 0.1155 1.0001 L 0.1135 0.9836 L 0.1011 0.9735 L 0.0875 0.966 L 0.0749 0.9546 L 0.0662 0.9409 L 0.0626 0.925 L 0.0594 0.909 L 0.0458 0.9002 L 0.0361 0.8868 L 0.0313 0.8715 L 0.0301 0.8546 L 0.0328 0.8384 L 0.0291 0.8234 L 0.0217 0.8091 L 0.0193 0.7928 L 0.0205 0.7759 L 0.0193 0.7591 L 0.0132 0.7443 L 0.0073 0.7294 L 0.006 0.7136 L 0.0149 0.6999 L 0.0141 0.6855 L 0.0031 0.6734 L 0 0.6574 L 0.0018 0.6408 L 0.0098 0.6268 L 0.012 0.6114 L 0.0058 0.5966 L 0.0024 0.5807 L 0.006 0.5648 L 0.012 0.55 L 0.0075 0.5345 L 0.0037 0.5188 L 0.0072 0.503 L 0.012 0.4876 L 0.0117 0.4714 L 0.0063 0.4563 L 0.0104 0.4409 L 0.0201 0.4276 L 0.0265 0.4129 L 0.0181 0.3998 L 0.0132 0.3844 L 0.0132 0.3681 L 0.0222 0.3545 L 0.0337 0.3433 L 0.0313 0.3279 L 0.0301 0.3111 L 0.0359 0.2962 L 0.0496 0.2873 L 0.0576 0.2766 L 0.0529 0.2611 L 0.0558 0.245 L 0.0682 0.2347 L 0.083 0.2286 L 0.0915 0.2176 L 0.0903 0.2008 L 0.0963 0.1859 L 0.1095 0.1769 L 0.1256 0.174 L 0.1264 0.1597 L 0.1295 0.1436 L 0.1428 0.1339 L 0.159 0.1312 L 0.1754 0.1288 L 0.1793 0.1132 L 0.183 0.0974 L 0.1956 0.0878 L 0.2125 0.0866 L 0.2298 0.0866 L 0.2431 0.0805 L 0.2479 0.0651 L 0.2621 0.0578 L 0.2789 0.0566 L 0.2948 0.0554 L 0.3085 0.0465 L 0.322 0.0373 L 0.3372 0.0328 L 0.3532 0.0337 L 0.368 0.0397 L 0.3835 0.0425 L 0.3899 0.0278 L 0.3995 0.0145 L 0.4143 0.0084 L 0.43 0.01 L 0.4437 0.0189 L 0.4569 0.0137 L 0.4676 0.0029 Z';

  // Rolling Tides + Fronda data. Sizes use long × short in inches.
  // For Rolling Tides "long" is the height (portrait); for Fronda
  // also portrait. Path is normalized 0..1 on the LONG axis.
  var TEMPLATES = {
    'rolling-tides': {
      eyebrow: 'Rolling Tides',
      path: ROLLING_TIDES_PATH,
      // viewBox y span when x span = 1 (i.e. shortAxis / longAxis × 1)
      // For Rolling Tides the path itself already spans 0..1 in both
      // axes (the source path is normalized to a 1×1 box).
      pathViewH: 1,
      sizes: [
        { label: "4'",  long: 48,  short: 36  },
        { label: "5'",  long: 60,  short: 48  },
        { label: "6'",  long: 72,  short: 60  },
        { label: "7'",  long: 84,  short: 72  },
        { label: "8'",  long: 96,  short: 84  },
        { label: "9'",  long: 108, short: 96  },
        { label: "10'", long: 120, short: 108 },
        { label: "11'", long: 132, short: 120 },
        { label: "12'", long: 144, short: 132 },
        { label: "13'", long: 156, short: 144 },
        { label: "14'", long: 168, short: 156 },
        { label: "15'", long: 180, short: 168 }
      ],
      inactiveFill: '#C9D7CE',
      defaultIdx: 4 // 8'
    },
    fronda: {
      eyebrow: 'Fronda',
      path: FRONDA_PATH,
      // Fronda's path is in a 0..1 × 0..1.2515 viewBox
      pathViewH: 1.2515,
      sizes: [
        { label: "4'",  long: 48,  short: 37  },
        { label: "5'",  long: 60,  short: 46  },
        { label: "6'",  long: 72,  short: 55  },
        { label: "7'",  long: 84,  short: 64  },
        { label: "8'",  long: 96,  short: 73  },
        { label: "9'",  long: 108, short: 82  },
        { label: "10'", long: 120, short: 91  },
        { label: "11'", long: 132, short: 100 },
        { label: "12'", long: 144, short: 109 },
        { label: "13'", long: 156, short: 118 },
        { label: "14'", long: 168, short: 127 },
        { label: "15'", long: 180, short: 136 }
      ],
      inactiveFill: '#D8CEC0',
      defaultIdx: 4
    }
  };

  /* ---------------------------------------------------------
     Room dimensions (feet) — bespoke uses tighter rooms than
     Phase 1 because the silhouettes need more breathing room.
     --------------------------------------------------------- */
  var ROOMS = [
    { key: 'living',  label: 'Living Room', w: 16, h: 12, ref: "7' sofa · 4' coffee table · two accent chairs" },
    { key: 'bedroom', label: 'Bedroom',     w: 14, h: 12, ref: "King bed (6.5' × 7') · two nightstands" },
    { key: 'dining',  label: 'Dining',      w: 14, h: 12, ref: "8' × 3.5' table · six chairs" },
    { key: 'entry',   label: 'Entry',       w: 12, h: 10, ref: "5' console table · 3' door swing" }
  ];
  var PPF = 17;

  /* ---------------------------------------------------------
     Furniture — same shapes/scale as the Phase 1 rectangle
     furniture, sized to fit the 16×12 / 14×12 bespoke rooms.
     Each returns SVG inner-markup positioned in a rw × rh
     room (feet), scaled by p (ppf).
     --------------------------------------------------------- */
  function kingBed(p, rw /*, rh*/) {
    var bedW = 6.5 * p, bedH = 7 * p;
    var bedX = (rw * p - bedW) / 2, bedY = 1 * p;
    var nsW = 2 * p, nsH = 1.5 * p;
    return (
      svgRect(bedX - 0.4 * p, bedY - 0.4 * p, bedW + 0.8 * p, 0.5 * p, 0) +
      svgRect(bedX, bedY, bedW, bedH, 3) +
      svgCushion(bedX + 0.5 * p, bedY + 0.4 * p, bedW / 2 - 0.75 * p, 1.2 * p, 3) +
      svgCushion(bedX + bedW / 2 + 0.25 * p, bedY + 0.4 * p, bedW / 2 - 0.75 * p, 1.2 * p, 3) +
      svgLine(bedX + 4, bedY + 2.8 * p, bedX + bedW - 4, bedY + 2.8 * p) +
      svgRect(bedX - nsW - 0.3 * p, bedY, nsW, nsH, 0) +
      svgRect(bedX + bedW + 0.3 * p, bedY, nsW, nsH, 0)
    );
  }
  var FURNITURE = {
    living: function (p, rw /*, rh*/) {
      var sofaW = 7 * p, sofaH = 3 * p;
      var sofaX = (rw * p - sofaW) / 2, sofaY = 1 * p;
      var tableW = 4 * p, tableH = 2 * p;
      var tableX = (rw * p - tableW) / 2, tableY = sofaY + sofaH + 1.5 * p;
      var chairW = 2.2 * p, chairH = 2.2 * p;
      return (
        svgRect(sofaX, sofaY, sofaW, sofaH, 4) +
        svgLine(sofaX + sofaW / 3, sofaY + 6, sofaX + sofaW / 3, sofaY + sofaH - 6) +
        svgLine(sofaX + 2 * sofaW / 3, sofaY + 6, sofaX + 2 * sofaW / 3, sofaY + sofaH - 6) +
        svgRect(tableX, tableY, tableW, tableH, 2) +
        svgRect(tableX - chairW - 1.2 * p, tableY - 0.3 * p, chairW, chairH, 4) +
        svgRect(tableX + tableW + 1.2 * p, tableY - 0.3 * p, chairW, chairH, 4)
      );
    },
    bedroom: kingBed,
    dining: function (p, rw, rh) {
      var tW = 8 * p, tH = 3.5 * p;
      var tX = (rw * p - tW) / 2, tY = (rh * p - tH) / 2;
      var chW = 1.6 * p, chH = 1.5 * p;
      var out = svgRect(tX, tY, tW, tH, 2);
      for (var i = 0; i < 3; i++) {
        var x = tX + (tW / 3) * i + (tW / 3 - chW) / 2;
        out += svgRect(x, tY - chH - 0.3 * p, chW, chH, 3);
        out += svgRect(x, tY + tH + 0.3 * p, chW, chH, 3);
      }
      return out;
    },
    entry: function (p, rw, rh) {
      // Console table centred against the back wall, two cushion-style
      // accents on top, and a 3' door-swing arc at the front wall.
      // Mirrors Phase 1's oval-entry layout.
      var cx = (rw / 2) * p;
      var consoleW = 5 * p, consoleH = 1.5 * p;
      var consoleX = cx - consoleW / 2;
      var consoleY = 0.8 * p;
      return (
        svgRect(consoleX, consoleY, consoleW, consoleH, 2) +
        svgCushion(consoleX + 0.6 * p, consoleY + 0.35 * p, 0.7 * p, 0.7 * p, 1) +
        svgCushion(consoleX + consoleW - 1.4 * p, consoleY + 0.3 * p, 0.9 * p, 0.85 * p, 1) +
        '<path d="M ' + r2(cx - 1.5 * p) + ' ' + r2(rh * p) +
          ' A ' + r2(3 * p) + ' ' + r2(3 * p) + ' 0 0 1 ' +
          r2(cx + 1.5 * p) + ' ' + r2(rh * p - 3 * p) +
          '" fill="none" stroke="' + INK + '" stroke-width="0.6" stroke-dasharray="3 4" opacity="0.45"/>' +
        svgLine(cx - 1.5 * p, rh * p, cx - 1.5 * p, rh * p - 3 * p)
      );
    }
  };

  /* ---------------------------------------------------------
     Silhouette renderers
     --------------------------------------------------------- */
  function silhouetteSvg(template, w, h, active) {
    var t = TEMPLATES[template];
    if (!t || !t.path || w <= 0 || h <= 0) return '';
    var d = scalePath01(t.path, w, h / t.pathViewH);
    var fill = active ? BRONZE : t.inactiveFill;
    var fillOpacity = active ? 0.9 : 0.7;
    var stroke = active ? 1.25 : 0.9;
    return (
      '<svg width="' + r2(w) + '" height="' + r2(h) +
      '" viewBox="0 0 ' + r2(w) + ' ' + r2(h) +
      '" style="overflow:visible;display:block">' +
        '<path d="' + d + '" fill="' + fill +
        '" fill-opacity="' + fillOpacity +
        '" stroke="' + INK + '" stroke-width="' + stroke +
        '" stroke-linejoin="round" opacity="' + (active ? 1 : 0.85) + '"/>' +
      '</svg>'
    );
  }

  function diagramSvg(template) {
    var W = 56, H = 56;
    var rugW = 30, rugH = 44;
    var rugX = (W - rugW) / 2;
    var rugY = (H - rugH) / 2 - 1;
    var t = TEMPLATES[template];
    var pathSvg = '';
    if (t && t.path) {
      var d = scalePath01(t.path, rugW, rugH / t.pathViewH);
      pathSvg =
        '<g transform="translate(' + rugX + ' ' + rugY + ')">' +
          '<path d="' + d + '" fill="#C9D7CE" fill-opacity="0.85" ' +
          'stroke="' + INK + '" stroke-width="1" stroke-linejoin="round"/>' +
        '</g>';
    }
    return (
      '<svg width="' + W + '" height="' + H +
      '" viewBox="0 0 ' + W + ' ' + H + '" style="overflow:visible">' +
        pathSvg +
        '<g stroke="' + INK + '" stroke-width="0.9">' +
          '<line x1="' + rugX + '" y1="' + (H - 2) + '" x2="' + (rugX + rugW) + '" y2="' + (H - 2) + '"/>' +
          '<line x1="' + rugX + '" y1="' + (H - 4) + '" x2="' + rugX + '" y2="' + H + '"/>' +
          '<line x1="' + (rugX + rugW) + '" y1="' + (H - 4) + '" x2="' + (rugX + rugW) + '" y2="' + H + '"/>' +
        '</g>' +
        '<g stroke="' + INK + '" stroke-width="0.9">' +
          '<line x1="' + (W - 2) + '" y1="' + rugY + '" x2="' + (W - 2) + '" y2="' + (rugY + rugH) + '"/>' +
          '<line x1="' + (W - 4) + '" y1="' + rugY + '" x2="' + W + '" y2="' + rugY + '"/>' +
          '<line x1="' + (W - 4) + '" y1="' + (rugY + rugH) + '" x2="' + W + '" y2="' + (rugY + rugH) + '"/>' +
        '</g>' +
      '</svg>'
    );
  }

  /* ---------------------------------------------------------
     Renderers
     --------------------------------------------------------- */
  function renderChips(root, template, sizeIdx, onPick) {
    var sizes = TEMPLATES[template].sizes;
    var html = '';
    for (var i = 0; i < sizes.length; i++) {
      var s = sizes[i];
      var on = i === sizeIdx;
      html +=
        '<button type="button" class="sgj__chip" data-sgjb-chip="' + i + '" aria-pressed="' + on + '">' +
          escapeAttr(s.label) +
        '</button>';
    }
    root.innerHTML = html;
    Array.prototype.forEach.call(root.querySelectorAll('[data-sgjb-chip]'), function (btn) {
      btn.addEventListener('click', function () {
        onPick(parseInt(btn.getAttribute('data-sgjb-chip'), 10));
      });
    });
  }

  function renderTabs(root, roomIdx, onPick) {
    var html = '';
    for (var i = 0; i < ROOMS.length; i++) {
      var r = ROOMS[i];
      var on = i === roomIdx;
      html +=
        '<button type="button" class="sgj__tab' + (on ? ' is-on' : '') + '" role="tab" aria-selected="' + on + '" data-sgjb-tab="' + i + '">' +
          escapeAttr(r.label) +
        '</button>';
    }
    root.innerHTML = html;
    Array.prototype.forEach.call(root.querySelectorAll('[data-sgjb-tab]'), function (btn) {
      btn.addEventListener('click', function () {
        onPick(parseInt(btn.getAttribute('data-sgjb-tab'), 10));
      });
    });
  }

  function renderOrientation(root, landscape, onPick) {
    // Markup mirrors Phase 1's server-rendered orientation buttons
    // exactly: no <span> wrapper around the label (theme CSS has
    // button span rules that leak in and bump font size), no is-on
    // class (CSS keys off aria-pressed), aria-hidden on the icon.
    root.innerHTML =
      '<button type="button" class="sgj__orientation-btn"' +
      ' data-sgjb-orient="portrait" aria-pressed="' + (!landscape) + '" aria-label="Portrait">' +
        '<svg width="10" height="14" viewBox="0 0 10 14" fill="none" stroke="currentColor" stroke-width="1.2" aria-hidden="true">' +
          '<rect x="0.6" y="0.6" width="8.8" height="12.8"/>' +
        '</svg>' +
        ' Portrait' +
      '</button>' +
      '<button type="button" class="sgj__orientation-btn"' +
      ' data-sgjb-orient="landscape" aria-pressed="' + landscape + '" aria-label="Landscape">' +
        '<svg width="14" height="10" viewBox="0 0 14 10" fill="none" stroke="currentColor" stroke-width="1.2" aria-hidden="true">' +
          '<rect x="0.6" y="0.6" width="12.8" height="8.8"/>' +
        '</svg>' +
        ' Landscape' +
      '</button>';
    Array.prototype.forEach.call(root.querySelectorAll('[data-sgjb-orient]'), function (btn) {
      btn.addEventListener('click', function () {
        onPick(btn.getAttribute('data-sgjb-orient') === 'landscape');
      });
    });
  }

  function renderCanvas(root, template, sizeIdx, roomIdx, landscape, silhouettes) {
    var t = TEMPLATES[template];
    var size = t.sizes[sizeIdx];
    var room = ROOMS[roomIdx];
    var canvasW = room.w * PPF;
    var canvasH = room.h * PPF;

    // long edge in feet, short edge in feet
    var longFt  = size.long  / 12;
    var shortFt = size.short / 12;
    var rugWFt = landscape ? longFt  : shortFt;
    var rugHFt = landscape ? shortFt : longFt;
    var rugWPx = rugWFt * PPF;
    var rugHPx = rugHFt * PPF;

    // Per-template + per-size placement. Bespoke silhouettes differ in
    // short-edge ratio (Rolling Tides ≈ 9/10, Fronda ≈ 7.6/10), which
    // changes which size "anchors" the couch/bed convincingly. Rolling
    // Tides hits ideal one size earlier than Fronda.
    var placement;
    if (room.key === 'living') {
      if (template === 'fronda') {
        // Fronda: keep every size centered so 10'→11'→12' grows
        // smoothly. A nudge on 11' alone makes it visually taller than
        // 12' (since 12' has a longer short-axis), which flips the
        // progression.
        placement = { cx: room.w / 2, cy: room.h / 2 + 0.5 };
      } else {
        // Rolling Tides: 10' is the deeper-anchor size.
        if (longFt >= 10 && longFt < 11) {
          placement = { cx: room.w / 2, cy: room.h / 2 - 1 };
        } else {
          placement = { cx: room.w / 2, cy: room.h / 2 + 0.5 };
        }
      }
    } else if (room.key === 'bedroom') {
      if (template === 'fronda') {
        // Fronda: 8' is still too small to anchor a king, so it
        // foot-anchors with the rest of the small sizes (4'–8').
        if (longFt < 9) {
          var rugHFootAnchorF = landscape ? shortFt : longFt;
          placement = { cx: room.w / 2, cy: 11 - rugHFootAnchorF / 2 };
        } else {
          placement = { cx: room.w / 2, cy: room.h / 2 + 0.5 };
        }
      } else {
        // Rolling Tides: 4'–7' foot-anchor; 10' sits a bit higher so it
        // visually wraps the king instead of dangling past the foot.
        if (longFt < 8) {
          var rugHFootAnchor = landscape ? shortFt : longFt;
          placement = { cx: room.w / 2, cy: 11 - rugHFootAnchor / 2 };
        } else if (longFt >= 10 && longFt < 11) {
          placement = { cx: room.w / 2, cy: room.h / 2 - 0.5 };
        } else {
          placement = { cx: room.w / 2, cy: room.h / 2 + 0.5 };
        }
      }
    } else if (room.key === 'dining') {
      placement = { cx: room.w / 2, cy: room.h / 2 };
    } else {
      placement = { cx: room.w / 2, cy: room.h / 2 + 0.5 };
    }
    var rugX = placement.cx * PPF - rugWPx / 2;
    var rugY = placement.cy * PPF - rugHPx / 2;

    // Look up the variant silhouette image for this size (preferred —
    // matches Phase 1's visual language). Falls back to the schematic
    // SVG path when no variant image is set.
    var sizeKey = String(size.label).replace(/['′\s]/g, '').toLowerCase();
    var imgUrl = silhouettes && silhouettes[sizeKey];

    var rugSvg;
    if (imgUrl) {
      if (landscape) {
        // Image source is portrait (long edge vertical). Rotate 90° about
        // the bbox top-right so it lands inside the landscape bbox.
        rugSvg =
          '<g transform="translate(' + r2(rugX + rugWPx) + ' ' + r2(rugY) + ') rotate(90)">' +
            '<image href="' + escapeAttr(imgUrl) +
            '" x="0" y="0" width="' + r2(rugHPx) + '" height="' + r2(rugWPx) +
            '" preserveAspectRatio="xMidYMid meet"/>' +
          '</g>';
      } else {
        rugSvg =
          '<image href="' + escapeAttr(imgUrl) +
          '" x="' + r2(rugX) + '" y="' + r2(rugY) +
          '" width="' + r2(rugWPx) + '" height="' + r2(rugHPx) +
          '" preserveAspectRatio="xMidYMid meet"/>';
      }
    } else if (landscape) {
      rugSvg =
        '<g transform="translate(' + r2(rugX) + ' ' + r2(rugY) + ')">' +
          '<g transform="translate(' + r2(rugWPx) + ' 0) rotate(90)">' +
            silhouetteSvg(template, rugHPx, rugWPx, true) +
          '</g>' +
        '</g>';
    } else {
      rugSvg =
        '<g transform="translate(' + r2(rugX) + ' ' + r2(rugY) + ')">' +
          silhouetteSvg(template, rugWPx, rugHPx, true) +
        '</g>';
    }

    var furniture = FURNITURE[room.key](PPF, room.w, room.h);

    // root is the <svg class="sgj__canvas"> element itself.
    // Set its viewBox/width/height and write children.
    root.setAttribute('viewBox', '0 0 ' + canvasW + ' ' + canvasH);
    root.setAttribute('width', canvasW);
    root.setAttribute('height', canvasH);
    root.setAttribute('preserveAspectRatio', 'xMidYMid meet');
    root.innerHTML =
      '<rect x="0.5" y="0.5" width="' + (canvasW - 1) +
      '" height="' + (canvasH - 1) +
      '" fill="none" stroke="' + BRONZE + '" stroke-width="1" stroke-dasharray="3 4" opacity="0.4"/>' +
      rugSvg +
      '<g>' + furniture + '</g>';
  }

  /* ---------------------------------------------------------
     Fit verdict — broad guidance per room based on the rug's
     long edge in feet. Bespoke shapes are organic so we avoid
     furniture-specific math (e.g. "fits sofa front legs"); the
     copy stays general and lets the customer judge.
     --------------------------------------------------------- */
  function fitVerdict(template, roomKey, size) {
    var label = size.label;
    var longFt = size.long / 12;
    if (template === 'fronda') {
      if (roomKey === 'living') {
        if (longFt < 6)  return { tone: 'small', label: 'Accent',     copy: 'A ' + label + ' rug reads as an accent — best as a side piece or in a reading nook, rather than the main seating anchor.' };
        if (longFt < 8)  return { tone: 'ideal', label: 'Ideal Fit',  copy: 'A ' + label + ' rug works as a coffee table accent — sits beneath the coffee table with seating arranged around it. Best in compact living rooms or as a layered accent.' };
        if (longFt < 11) return { tone: 'ideal', label: 'Ideal Fit',  copy: 'A ' + label + ' rug anchors a coffee table with the front legs of seating on the rug. A balanced fit for most living rooms.' };
        if (longFt < 12) return { tone: 'ideal', label: 'Ideal Fit',  copy: 'A ' + label + ' rug spans the seating group with the coffee table and front legs of seating on the rug. A balanced fit for full-size living rooms.' };
        return                  { tone: 'tight', label: 'Generous',   copy: 'A ' + label + ' rug spans the full seating group with most furniture on the rug. Best in larger living rooms.' };
      }
      if (roomKey === 'bedroom') {
        if (longFt < 9)  return { tone: 'small', label: 'Accent',     copy: 'A ' + label + ' rug works as a bedside or foot-of-bed accent — not large enough to anchor a queen or king bed on its own.' };
        if (longFt < 12) return { tone: 'ideal', label: 'Ideal Fit',  copy: 'A ' + label + ' rug extends past the bed for visible rug on the sides and foot. A balanced fit for queen and king setups.' };
        return                  { tone: 'tight', label: 'Generous',   copy: 'A ' + label + ' rug wraps the bed with rug visible on every side. Best in larger bedrooms.' };
      }
      if (roomKey === 'dining') {
        if (longFt < 11) return { tone: 'small', label: 'Too Small',  copy: 'A ' + label + ' rug is too small for a six-seat dining table — chairs slide off the edge when pulled out.' };
        if (longFt < 14) return { tone: 'ideal', label: 'Ideal Fit',  copy: 'A ' + label + ' rug keeps chairs on the rug when pulled out. A balanced fit for 6–8-seat tables.' };
        return                  { tone: 'tight', label: 'Generous',   copy: 'A ' + label + ' rug suits an 8+ seat table or open-plan dining. Confirm clearance to surrounding walls.' };
      }
    } else {
      if (roomKey === 'living') {
        if (longFt < 6)  return { tone: 'small', label: 'Accent',     copy: 'A ' + label + ' rug reads as an accent — best as a side piece or in a reading nook, rather than the main seating anchor.' };
        if (longFt < 7)  return { tone: 'ideal', label: 'Ideal Fit',  copy: 'A ' + label + ' rug works as a coffee table accent — sits beneath the coffee table with seating arranged around it. Best in compact living rooms or as a layered accent.' };
        if (longFt < 10) return { tone: 'ideal', label: 'Ideal Fit',  copy: 'A ' + label + ' rug anchors a coffee table with the front legs of seating on the rug. A balanced fit for most living rooms.' };
        if (longFt < 11) return { tone: 'ideal', label: 'Ideal Fit',  copy: 'A ' + label + ' rug runs deeper under the couch, with all four legs landing on the rug. A balanced fit for full-size living rooms.' };
        return                  { tone: 'tight', label: 'Generous',   copy: 'A ' + label + ' rug spans the full seating group with most furniture on the rug. Best in larger living rooms.' };
      }
      if (roomKey === 'bedroom') {
        if (longFt < 8)  return { tone: 'small', label: 'Accent',     copy: 'A ' + label + ' rug works as a bedside or foot-of-bed accent — not large enough to anchor a queen or king bed on its own.' };
        if (longFt < 10) return { tone: 'ideal', label: 'Ideal Fit',  copy: 'A ' + label + ' rug extends past the bed for visible rug on the sides and foot. A balanced fit for queen and king setups.' };
        if (longFt < 11) return { tone: 'ideal', label: 'Ideal Fit',  copy: 'A ' + label + ' rug wraps under the bed with rug visible on every side. A balanced fit for king setups.' };
        return                  { tone: 'tight', label: 'Generous',   copy: 'A ' + label + ' rug wraps the bed with rug visible on every side. Best in larger bedrooms.' };
      }
      if (roomKey === 'dining') {
        if (longFt < 10) return { tone: 'small', label: 'Too Small',  copy: 'A ' + label + ' rug is too small for a six-seat dining table — chairs slide off the edge when pulled out.' };
        if (longFt < 14) return { tone: 'ideal', label: 'Ideal Fit',  copy: 'A ' + label + ' rug keeps chairs on the rug when pulled out. A balanced fit for 6–8-seat tables.' };
        return                  { tone: 'tight', label: 'Generous',   copy: 'A ' + label + ' rug suits an 8+ seat table or open-plan dining. Confirm clearance to surrounding walls.' };
      }
    }
    if (roomKey === 'entry') {
      if (longFt < 5)  return { tone: 'small', label: 'Accent',     copy: 'A ' + label + ' rug reads as a small accent — works for tight foyers or beneath a console.' };
      if (longFt < 9)  return { tone: 'ideal', label: 'Ideal Fit',  copy: 'A ' + label + ' rug anchors a typical foyer. Check the door-swing clearance for the size you choose.' };
      return                  { tone: 'tight', label: 'Generous',   copy: 'A ' + label + ' rug suits a long gallery or grand foyer. Confirm door clearance in standard entries.' };
    }
    return { tone: 'ideal', label: 'Ideal Fit', copy: '' };
  }

  function renderFit(root, template, roomKey, size) {
    var v = fitVerdict(template, roomKey, size);
    root.setAttribute('data-tone', v.tone);
    var labelEl = root.querySelector('[data-sgj-fit-label]');
    var copyEl  = root.querySelector('[data-sgj-fit-copy]');
    if (labelEl) labelEl.textContent = v.label;
    if (copyEl)  copyEl.textContent  = v.copy;
  }

  function renderReference(root, template, sizeIdx, roomIdx, landscape) {
    var size = TEMPLATES[template].sizes[sizeIdx];
    var room = ROOMS[roomIdx];
    var dims = landscape
      ? size.short + '" × ' + size.long + '"'
      : size.long + '" × ' + size.short + '"';
    root.innerHTML =
      'Reference · ' + room.w + '\' × ' + room.h + '\' room · ' +
      escapeAttr(size.label) + ' rug (' + dims + ' ' +
      (landscape ? 'landscape' : 'portrait') + ')';
  }

  function renderTable(root, template, sizeIdx, onPick) {
    var sizes = TEMPLATES[template].sizes;
    var html = '';
    for (var i = 0; i < sizes.length; i++) {
      var s = sizes[i];
      var on = i === sizeIdx;
      html +=
        '<div class="sgjb__table-row' + (on ? ' is-on' : '') + '" role="row" data-sgjb-row="' + i + '">' +
          '<span role="cell" class="sgjb__table-size">' + escapeAttr(s.label) + '</span>' +
          '<span role="cell">' + s.long + '″ × ' + s.short + '″</span>' +
          '<span role="cell">' + inToCm(s.long) + ' × ' + inToCm(s.short) + ' cm</span>' +
        '</div>';
    }
    root.innerHTML = html;
    Array.prototype.forEach.call(root.querySelectorAll('[data-sgjb-row]'), function (row) {
      row.addEventListener('click', function () {
        onPick(parseInt(row.getAttribute('data-sgjb-row'), 10));
      });
    });
  }

  /* ---------------------------------------------------------
     Mount
     --------------------------------------------------------- */
  function init(root) {
    var dataId = root.getAttribute('data-sgjb-mount');
    var dataEl = document.querySelector('script[data-sgjb-data="' + dataId + '"]');
    if (!dataEl) return;
    var cfg;
    try { cfg = JSON.parse(dataEl.textContent); }
    catch (e) { return; }
    var template = cfg.template;
    var t = TEMPLATES[template];
    if (!t) return;
    var silhouettes = cfg.silhouettes || {};

    var state = {
      sizeIdx: t.defaultIdx,
      roomIdx: 0,
      landscape: false
    };

    var diagramEl = root.querySelector('[data-sgjb-diagram]');
    var chipsEl   = root.querySelector('[data-sgjb-chips]');
    var tabsEl    = root.querySelector('[data-sgjb-tabs]');
    var canvasEl  = root.querySelector('[data-sgjb-canvas]');
    var refEl     = root.querySelector('[data-sgjb-reference]');
    var orientEl  = root.querySelector('[data-sgjb-orientation]');
    var tableEl   = root.querySelector('[data-sgjb-table-body]');
    var fitEl     = root.querySelector('[data-sgj-fit]');

    // Diagram is rendered by Liquid when a variant silhouette is
    // available; only fall back to the JS path-drawing diagram when
    // the snippet leaves [data-sgjb-diagram] empty.
    if (diagramEl) diagramEl.innerHTML = diagramSvg(template);

    function pickSize(i) {
      state.sizeIdx = i;
      paint();
    }
    function pickRoom(i) {
      state.roomIdx = i;
      paint();
    }
    function pickOrient(landscape) {
      state.landscape = landscape;
      paint();
    }

    function paint() {
      if (chipsEl)  renderChips(chipsEl, template, state.sizeIdx, pickSize);
      if (tabsEl)   renderTabs(tabsEl, state.roomIdx, pickRoom);
      if (canvasEl) renderCanvas(canvasEl, template, state.sizeIdx, state.roomIdx, state.landscape, silhouettes);
      if (refEl)    renderReference(refEl, template, state.sizeIdx, state.roomIdx, state.landscape);
      if (orientEl) renderOrientation(orientEl, state.landscape, pickOrient);
      if (tableEl)  renderTable(tableEl, template, state.sizeIdx, pickSize);
      if (fitEl)    renderFit(fitEl, template, ROOMS[state.roomIdx].key, t.sizes[state.sizeIdx]);
    }

    paint();
  }

  function bootAll() {
    Array.prototype.forEach.call(
      document.querySelectorAll('.sgjb[data-sgjb-mount]'),
      function (el) { if (!el.__sgjbBooted) { el.__sgjbBooted = true; init(el); } }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll);
  } else {
    bootAll();
  }

  // Drawer support — re-scan when content is inserted late.
  if (typeof MutationObserver !== 'undefined') {
    new MutationObserver(bootAll).observe(document.body, { childList: true, subtree: true });
  }
})();
